import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { App } from '@df/core/app';
import find from 'lodash-es/find';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';
import { Meta } from '@df/core/meta/meta';
import { ProcessorService } from '@df/ng/processor.service';
import { NSession } from '../df-session.config';

@Injectable({
    providedIn: 'root'
})
export class RespectMustLoginService {
    customerStatusSubscription?: Subscription;

    private moduleConfig = inject(NSession.OPTIONS);
    /**
     * Sets Observer on customer status change if login is required
     */
    constructor(
        private app: App,
        private router: Router,
        private meta: Meta,
        private customerLoggedGuard: CustomerLoggedGuard
    ) {
        if (this.mustLogin()) {
            ProcessorService.onReady(() => {
                this.meta.routerEvents.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe(() => {
                    if (!this.customerStatusSubscription) {
                        this.customerStatusSubscription = this.app.customer.model.obs.status.subscribe((isLoggedIn: boolean) =>
                            this.update()
                        );
                    }
                    this.app.customer.model.load().finally(() => {
                        this.update();
                    });
                });
            });
        }
    }

    protected mustLogin(): boolean {
        return this.app.data.mustLogin || false;
    }

    /**
     * Checks if customer can access current route even if not logged in
     */
    private get routeIsAllowed(): boolean {
        return !!find(this.moduleConfig.notRespectMustLoginRoutes, (route: RegExp) => this.router.url.match(route));
    }

    /**
     * Checks if customer can access current route, if not redirects
     */
    private update(): void {
        if (!this.isCustomerAllowed() && !this.routeIsAllowed) {
            this.customerLoggedGuard.onError();
        }
    }

    protected isCustomerAllowed(): boolean {
        return this.app.customer.model.isLoggedIn;
    }
}
